import React from 'react';

import { Card, CardContent, Grid, Typography } from '@mui/material';
import { COLOR_GREY_600 } from 'src/utils/colors';

const DataChartTooltip = ({
  data,
}: {
  data: { name?: string; dataKey: string; val: string; color: string }[];
}) => {
  return (
    <Card sx={{ boxShadow: `0px 0px 10px 0px ${COLOR_GREY_600}`, p: 0, m: 0 }}>
      <CardContent style={{ padding: '10px', margin: 0 }}>
        {data.map(data => (
          <Grid container direction="column">
            {data.name && (
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {data.name}
              </Typography>
            )}
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              {data.dataKey}: <span style={{ color: data.color }}>{data.val}</span>
            </Typography>
          </Grid>
        ))}
      </CardContent>
    </Card>
  );
};

export default DataChartTooltip;
